import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const VibrationChart = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <div className="bob-chart-container">
                <h4>Vibration History</h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.5)' }}>No data available</p>
            </div>
        );
    }

    const formattedData = data.map(item => ({
        ...item,
        time: new Date(item.timestamp).toLocaleString('en', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }));

    return (
        <div className="bob-chart-container">
            <h4>Vibration History</h4>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={formattedData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                    <XAxis
                        dataKey="time"
                        stroke="rgba(255,255,255,0.5)"
                        tick={{ fontSize: 11 }}
                    />
                    <YAxis stroke="rgba(255,255,255,0.5)" tick={{ fontSize: 11 }} />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#1a1a2e',
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '8px'
                        }}
                        labelStyle={{ color: '#fff' }}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="vibration_level"
                        name="Average Vibration"
                        stroke="#6366f1"
                        strokeWidth={2}
                        dot={false}
                    />
                    <Line
                        type="monotone"
                        dataKey="max_vibration"
                        name="Max Vibration"
                        stroke="#f59e0b"
                        strokeWidth={2}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default VibrationChart;
